import { useTranslation } from 'react-i18next';
import { ReactComponent as ArrowRightIcon } from 'assets/icons/arrow-right.svg';
import Button from 'components/Button/Button';
import EmptyTaskManagement from 'components/EmptyTaskManagement/EmptyTaskManagement';
import StepItem from 'components/StepItem/StepItem';
import TitleTableWrapper from 'components/TitleTableWrapper/TitleTableWrapper';
import TitleWrapper from 'components/TitleWrapper/TitleWrapper';
import { TASK_HEAD_COMMUNITIES_CELLS } from 'constants/dataSets';
import { BUTTON_VARIANT } from 'constants/interfaces';

import CreateCommunities from './components/CreateCommunities/CreateCommunities';
import ItemsTable from './components/ItemsTable/ItemsTable';

import type IMaterialityAssessmentCommunities from './interfaces/IMaterialityAssessmentCommunities';

import styles from './scss/MaterialityAssessmentCommunities.module.scss';

function MaterialityAssessmentCommunitiesView({
  isEmptyList, loading, addStakeholder, goBack, goToNextMaterialityAssessment, openModal,
  communities, onEditRecord, onLoadMore, hasMore, isLoadingMore, onDeleteItem,
  selectedItem, recordId, currentId, setCommunities, setOpenModal,
  vcmName, vcmId, isViewOnly = false,
}: IMaterialityAssessmentCommunities) {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <span className={styles.header}>{t('materialityAssessment.titleStakeholder', { vcmName })}</span>
      <div className={styles.rootContainer}>
        <div className={styles.wrapper}>
          <TitleWrapper
            description={t('materialityAssessment.titleStakeholderDescription')}
          />

          <div className={styles.stepStakeholder}>
            <StepItem title={t('materialityAssessment.titleStepStakeholder')} step={1} done />
            <ArrowRightIcon />
            <StepItem title={t('materialityAssessment.titleSecondStepStakeholder')} step={2} />
          </div>

          <TitleTableWrapper
            title={t('materialityAssessment.importantLocalCommunities')}
            buttonTitle={t('materialityAssessment.addCommunity')}
            onButtonClick={addStakeholder}
            buttonClassName={styles.button}
            showButton={!isEmptyList && !isViewOnly}
          />
          <div className={styles.contentWrapper}>
            {isEmptyList && !loading ? (
              <EmptyTaskManagement
                title={t('materialityAssessment.emptyCommunityDescription')}
                buttonTitle={t('materialityAssessment.addStakeholder')}
                buttonOnClick={addStakeholder}
                disabledButton={isViewOnly}
              />
            ) : (
              <div className={styles.tableWrapper}>
                {communities.length > 0 && (
                  <ItemsTable
                    items={communities}
                    headCells={TASK_HEAD_COMMUNITIES_CELLS}
                    onEditRecord={onEditRecord}
                    onLoadMore={onLoadMore}
                    hasMore={hasMore}
                    isLoadingMore={isLoadingMore}
                    onDeleteItem={onDeleteItem}
                    isInfoTable
                    isViewOnly={isViewOnly}
                  />
                )}
              </div>
            )}
          </div>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            title={t('common.cancel')}
            variant={BUTTON_VARIANT.cancel}
            className={styles.button}
            onClick={goBack}
          />
          <Button
            title={t('common.next')}
            onClick={goToNextMaterialityAssessment}
            className={styles.button}
          />
        </div>
      </div>
      <CreateCommunities
        open={openModal}
        onClose={addStakeholder}
        title={t('materialityAssessment.addLocalCommunity')}
        selectedItem={selectedItem}
        recordId={recordId}
        currentId={currentId}
        setCommunities={setCommunities}
        setOpenModal={setOpenModal}
        vcmId={vcmId}
      />
    </div>
  );
}

export default MaterialityAssessmentCommunitiesView;
